import {
    CheckCircleOutlined, StopOutlined,
} from '@ant-design/icons';
import * as Antd from 'antd';

type ActionScriptToggleButtonProps = {
    /** true = скрипт зараз активний (кнопка деактивації) */
    isActive: boolean;
    onClick: React.MouseEventHandler<HTMLElement>;
    disabled?: boolean;
    styles?: Object;
};

export const ActionScriptToggleButton = ({
    isActive,
    onClick,
    disabled,
    styles = {},
}: ActionScriptToggleButtonProps) => {
    const { token } = Antd.theme.useToken();

    const borderColor = disabled
        ? token.colorBorder
        : (isActive ? token.colorError : token.colorSuccess);
    const iconColor = disabled
        ? token.colorTextDisabled
        : (isActive ? token.colorError : token.colorSuccess);

    const tooltipTitle = isActive ? 'Деактивувати скрипт' : 'Активувати скрипт';

    return (
        <Antd.Tooltip title={tooltipTitle}>
            <Antd.Button
                type="text"
                icon={
                    isActive ? (
                        <StopOutlined style={{ fontSize: 16, color: iconColor }} />
                    ) : (
                        <CheckCircleOutlined style={{ fontSize: 16, color: iconColor }} />
                    )
                }
                onClick={onClick}
                disabled={disabled}
                style={{
                    width: 32,
                    height: 32,
                    padding: 0,
                    border: `1px solid ${borderColor}`,
                    backgroundColor: disabled ? token.colorBgContainerDisabled : 'transparent',
                    ...styles,
                }}
            />
        </Antd.Tooltip>
    );
};
